import React from "react";
import InfoSidebar from "../../elements/sidebar/InfoSidebar/InfoSidebar";
import PayablesSideBar from "../../components/payables/PayablesSideBar";
import commoncss from "../../css/common.module.css";

export default function ComputeCalculation() {
  return (
    <>
      <div style={{ display: "flex" }}>
        <PayablesSideBar activeTab={"Overview"} />
        <div className={`${commoncss.widthScrHidden} px-3 py-2`}>
          <h2>Overview Page</h2>
        </div>
      </div>
    </>
  );
}
